import React, { ReactElement, useEffect, useState } from 'react';
import { Button, Col, Table } from 'antd';
import { deselectIntersections } from '../../store/entities/pm';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import { IntersectionId } from '../../types/primitives';

interface DataRow {
  key: IntersectionId,
  name: string,
  trajCnt: number | string
}

const PenetrationTable = (): ReactElement => {
  const dispatch = useAppDispatch();
  const availableIntersections = useAppSelector((state) => (
    state.entities.pm.availableIntersections));
  const selectedIntersections = useAppSelector((state) => (
    state.entities.pm.selectedIntersections));
  const intersectionTrajCountDict = useAppSelector((state) => (
    state.entities.pm.intersectionTrajCountDict));
  const [dataSource, setDataSource] = useState<DataRow[]>([]);

  const handleDelete = (key: IntersectionId) => dispatch(deselectIntersections([key]));

  const columns = [
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: 'No. Trips',
      dataIndex: 'trajCnt',
      key: 'trajCnt',
    },
    {
      title: '',
      dataIndex: 'operation',
      render: (value: unknown, row: DataRow) => {
        if (selectedIntersections.length) {
          const del = () => handleDelete(row.key);
          return <Button onClick={del}>🗑️</Button>;
        }
        return null;
      },
    },
  ];

  useEffect(() => {
    interface DataElement {
      key: IntersectionId,
      name: string,
      trajCnt: number | string
    }

    const data: DataElement[] = selectedIntersections
      .slice()
      .reverse()
      .reduce((acc: DataElement[], intersectionId: IntersectionId) => {
        const intersections = availableIntersections
          .filter((i) => i.intersectionId === intersectionId);

        if (!intersections.length) return acc;

        let trajCnt: number | string = '-';

        if (intersectionTrajCountDict) {
          trajCnt = intersectionTrajCountDict[intersectionId] || '-';
        }

        acc.push({
          key: intersectionId,
          name: intersections[0].intersectionName,
          trajCnt,
        });

        return acc;
      }, []);
    setDataSource(data);
  }, [selectedIntersections, intersectionTrajCountDict]);

  return (
    <Col style={{
      height: '100%',
      width: '100%',
    }}
    >
      <div className="input-label" style={{ paddingBottom: '0.5em' }}>Intersections</div>
      <Table style={{ width: '100%' }} size="small" dataSource={dataSource} columns={columns} />
    </Col>
  );
};
export default PenetrationTable;
